import APIServiceLookUp from './serviceAPI';
import { API_URL, MAIN_API_URL } from './models/AppConstent';

export default class ServiceStaff {
    lookupService = new APIServiceLookUp();

    async getAllUsers(body, orgid) {
        var serviceType = "CUST";
        var url = `${API_URL}outlet/getAllOutletStaff`;
        var apiService = this.lookupService.getAPIService(serviceType);
        var requestHeaders = {
            'Content-type': 'application/json',
            'Accept': 'application/json',
            'x-org-id': orgid,
        };
        return await apiService.doCall(url, body, requestHeaders);
    }

    async updateStaffPosUser(body, orgid) {
        var serviceType = "CUST";
        var url = `${API_URL}outlet/updateStaffPosUser`;
        var apiService = this.lookupService.getAPIService(serviceType);
        var requestHeaders = {
            'Content-type': 'application/json',
            'Accept': 'application/json',
            'x-org-id': orgid,
        };
        return await apiService.doCall(url, body, requestHeaders);
    }

    async updatePOSUser(body, orgid) {
        var serviceType = "CUST";
        var url = `${API_URL}outlet/updatePOSUser`;
        var apiService = this.lookupService.getAPIService(serviceType);
        var requestHeaders = {
            'Content-type': 'application/json',
            'Accept': 'application/json',
            'x-org-id': orgid,
        };
        return await apiService.doCall(url, body, requestHeaders);
    }

    async registerPOSUser(body, orgid) {
        var serviceType = "CUST";
        var url = `${API_URL}auth/registerPOSUser`;
        var apiService = this.lookupService.getAPIService(serviceType);
        var requestHeaders = {
            'Content-type': 'application/json',
            'Accept': 'application/json',
            'x-org-id': orgid,
        };
        return await apiService.doCall(url, body, requestHeaders);
    }
}